import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetRutaParte = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/rutas_partes/${params}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getRutaParteMutation: mutation.mutate,
    };
}